webpackJsonp([5],{

/***/ "1Wuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return viewer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getImgUrl__ = __webpack_require__("5Oux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__("wszR");



var viewer = {
  getImgUrl: __WEBPACK_IMPORTED_MODULE_0__getImgUrl__["a" /* getImgUrl */],
  init: __WEBPACK_IMPORTED_MODULE_1__init__["a" /* init */]
};

/***/ }),

/***/ "2/Dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return swiper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__imgResize__ = __webpack_require__("Ckst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__("Hzht");



var swiper = {
  init: __WEBPACK_IMPORTED_MODULE_1__init__["a" /* init */],
  imgResize: __WEBPACK_IMPORTED_MODULE_0__imgResize__["a" /* imgResize */]
};

/***/ }),

/***/ "5++7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_page_gift_scss__ = __webpack_require__("5PET");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_page_gift_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_page_gift_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_common_index__ = __webpack_require__("4PxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_animation_index__ = __webpack_require__("iu1/");







function bindEvts() {
  giftDeliveryInit();
  memberFormInit();
  swipersInit();
  rcmdJump();
  giftRankInit();
}

function memberFormInit() {
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].closeForm.init();
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].loginFormInit({
    success: function success() {
      return Object(__WEBPACK_IMPORTED_MODULE_1_js_common_index__["l" /* headerInit */])();
    },
    form: '.yui-memberform0-login',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member'
  });
}

function giftDeliveryInit() {
  var data = {
    list: '.sec-top .list-container.selected',
    target: '.sec-top .top-rt'
  };

  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["f" /* anotherBatch */].init(data);

  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["g" /* blkNavTag */].init({
    tagList: '.sec-top .tag-container',
    blkList: '.sec-top .list-containers',
    callback: {
      f: __WEBPACK_IMPORTED_MODULE_1_js_common_index__["f" /* anotherBatch */].init,
      data: data
    }
  });
}

function rcmdJump() {
  $('.sec-lft2').on('click', '.btn-download', function (e) {
    e.preventDefault();
    var href = this.getAttribute('data-href');
    window.location.href =  true ? href : '' + SERVER_URL + href;
  });
}

function giftRankInit() {
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["g" /* blkNavTag */].init({
    tagList: '.sec-rt2 .tag-container',
    blkList: '.sec-rt2 .list-containers'
  });
}

function swipersInit() {
  __WEBPACK_IMPORTED_MODULE_2_js_animation_index__["a" /* swiper */].init({
    selector: '.swiper0',
    options: {
      pagination: {
        bulletActiveClass: 'selected',
        bulletClass: 'dot',
        clickable: true,
        el: '.swiper-pagination-bullets'
      }
    }
  });

  __WEBPACK_IMPORTED_MODULE_2_js_animation_index__["a" /* swiper */].init({
    selector: '.swiper1',
    options: {
      autoplay: {
        delay: 2000
      },
      direction: 'vertical',
      loop: true,
      slidesPerView: 6
    }
  });
}

function uiInit() {}

window._dataBus.get('domReadyObserver').subscribe(function () {
  uiInit();
  bindEvts();
});

/***/ }),

/***/ "5Oux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getImgUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_constants_index__ = __webpack_require__("5LvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_utils_index__ = __webpack_require__("EgtA");








function getImgUrl() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, options);

  if (!(argsInit(options) && argsValidate(options))) {
    return false;
  }

  var _options = options,
      imgs = _options.imgs;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {

    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(imgs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var img = _step.value;

      img.setAttribute(__WEBPACK_IMPORTED_MODULE_3_js_constants_index__["e" /* propertyName */].viewer.hdUrl, img.getAttribute('src').replace(__WEBPACK_IMPORTED_MODULE_3_js_constants_index__["c" /* imgRegExp */].hdUrlFilter, ''));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return true;
}

function argsInit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imgs = options.imgs;


  if (typeof imgs === 'string') {
    var obj = document.querySelectorAll(imgs);

    if (obj.length === 0) {
      __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e('[viewer][getImgUrl][argsInit] DOM element whose selector\'s ' + wrapper + ' not found.');
      return false;
    }

    options.imgs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(obj);
  }

  return true;
}

function argsValidate() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imgs = options.imgs;

  var from = '[viewer][getImgUrl][argsValidate]';

  if (imgs instanceof Array) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(imgs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var img = _step2.value;

        if (!(img instanceof Image)) {
          __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e(from + ' img isn\'t an instance of Image.');
          return false;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e(from + ' imgs isn\'t an instance of Array.');
    return false;
  }

  return true;
}

/***/ }),

/***/ "5PET":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ckst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imgResize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_utils_index__ = __webpack_require__("EgtA");








function imgResize() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, options);

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!(argsInit(options) && argsValidate(options))) {
      return reject();
    }

    var _options = options,
        imgs = _options.imgs,
        ht = _options.ht;

    var maxLen = imgs.length;
    var cnt = 0;

    var timer = setInterval(function () {
      var _loop = function _loop(img) {
        if (img.complete) {
          if (typeof img.naturalWidth !== 'undefined') {
            var ratio = img.naturalWidth / img.naturalHeight;
            var wt = void 0;
            var height = void 0;
            var unit = void 0;

            if (ratio > 1) {
              height = ht.horiz.value;
              unit = ht.horiz.unit;
            } else {
              height = ht.verti.value;
              unit = ht.verti.unit;
            }

            wt = (height * ratio).toFixed(3) * 1000 / 1000;

            $(img).css({
              'width': '' + wt + unit,
              'height': '' + height + unit
            });
            $(img).parent('.swiper-slide').css({
              'width': '' + wt + unit
            });

            var index = imgs.findIndex(function (ele) {
              return img === ele;
            });
            imgs.splice(index, 1);
            cnt++;
          } else {
            __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e('[posterInit] failed: 浏览器不支持 naturalWidth 属性');
            reject();
            clearInterval(timer);
            return 'break';
          }
        }

        if (cnt >= maxLen) {
          resolve();
          clearInterval(timer);
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(imgs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var img = _step.value;

          var _ret = _loop(img);

          if (_ret === 'break') break;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }, 300);
  });
}

function argsInit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imgs = options.imgs,
      _options$ht = options.ht,
      ht = _options$ht === undefined ? {
    horiz: {
      value: 8.75,
      unit: 'rem'
    },
    verti: {
      value: 12.75,
      unit: 'rem'
    }
  } : _options$ht;


  options.ht = ht;

  if (typeof imgs === 'string') {
    var obj = document.querySelectorAll(imgs);

    if (obj.length === 0) {
      __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(from + '[argsInit] DOM element whose selector\'s ' + imgs + ' not found.');
      return false;
    }

    options.imgs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(obj);
  }

  if ((typeof ht === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(ht)) === 'object') {
    options.ht = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({
      horiz: {
        value: 8.75,
        unit: 'rem'
      },
      verti: {
        value: 12.75,
        unit: 'rem'
      }
    }, ht);
  }

  return true;
}

function argsValidate() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imgs = options.imgs,
      ht = options.ht;

  var from = '[swiper][imgResize][argsValidate]';

  if (imgs instanceof Array) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(imgs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var img = _step2.value;

        if (!(img instanceof HTMLElement)) {
          __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(from + ' img is not an instance of Image.');
          return false;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(from + ' imgs is not an instance of Array.');
    return false;
  }

  if ((typeof ht === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(ht)) !== 'object') {
    __WEBPACK_IMPORTED_MODULE_5_js_utils_index__["f" /* log */].e(from + ' invalid argument ht.');
    return false;
  }

  return true;
}

/***/ }),

/***/ "Hzht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);



function init() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$selector = _ref.selector,
      selector = _ref$selector === undefined ? '.swiper-container' : _ref$selector,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options;

  var opts = {
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    initialSlide: 0,
    observer: true,
    observeParents: true,
    paginationElement: 'li',
    resistance: true,
    resistanceRatio: 0.85
  };
  var objArr = [];

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(opts, options);

  if (!(selector instanceof Array) && typeof selector !== 'string') {
    return utils.log.e('[swiper][init] invalid argument: selector', selector);
  }

  if (selector instanceof Array) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selector), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var obj = _step.value;

        obj = new Swiper(obj, opts);
        objArr.push(obj);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else {
    objArr.push(new Swiper(selector, opts));
  }

  return objArr;
}

/***/ }),

/***/ "iu1/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_index__ = __webpack_require__("2/Dm");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__swiper_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__viewer_index__ = __webpack_require__("1Wuk");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__viewer_index__["a"]; });



/***/ }),

/***/ "wszR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_constants_index__ = __webpack_require__("5LvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_utils_index__ = __webpack_require__("EgtA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getImgUrl__ = __webpack_require__("5Oux");








function init() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options);

  if (!(argsInit(options) && argsValidate(options))) {
    return false;
  }

  var _options = options,
      wrapper = _options.wrapper;

  var viewer = new Viewer(wrapper, {
    url: __WEBPACK_IMPORTED_MODULE_1_js_constants_index__["e" /* propertyName */].viewer.hdUrl
  });

  return viewer;
}

function argsInit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var from = '[viewer][init]';

  if (!__WEBPACK_IMPORTED_MODULE_2_js_utils_index__["b" /* args */].init.selector({
    args: options,
    from: from,
    name: 'wrapper'
  })) {
    return false;
  }

  return true;
}

function argsValidate() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var from = '[viewer][init]';

  if (!__WEBPACK_IMPORTED_MODULE_2_js_utils_index__["b" /* args */].validate.instance({
    args: options,
    from: from,
    name: 'wrapper'
  })) {
    return false;
  }

  return true;
}

/***/ })

},["5++7"]);


// WEBPACK FOOTER //
// js/gift.js